import { LazyRoute } from '@app/components/lazy-route';
import React, { lazy } from 'react';

const ActiveMemberPage = lazy(() => import('./active-members-page'));

const ActiveMemberRoute = () => {
  return (
    <LazyRoute>
      <ActiveMemberPage />
    </LazyRoute>
  );
};

export { ActiveMemberRoute };
